/**
 * DEMO-BUTTON-1 (a) — which site this is, for the 'Run demo' link.
 * Only a DEV or QA Azure host has an env; every other host (including any
 * production name) gets null, so the button is hidden there. Same host rule
 * as the robot's guard (scripts/demo/robot_cases.mjs baseUrls).
 */
export type DemoEnv = 'dev' | 'qa'

export function demoEnvForHost(hostname: string): DemoEnv | null {
  const m = /^[a-z0-9-]+-(dev|qa)\.azurewebsites\.net$/.exec(hostname)
  return m ? (m[1] as DemoEnv) : null
}

/** The link the presenter's PC hands to the robot. Scheme, mode and env only — never a login or token. */
export function demoLink(env: DemoEnv): string {
  return `yansar-demo:run?mode=tour&env=${env}`
}
